

<!-- <!DOCTYPE html>
<html class="no-js" lang="zxx">

<head>
    <meta charset="utf-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
 
    <link rel="icon" href="../../../assets/images/banners/mit-favicon.png" />

  
    <script async src="https://www.googletagmanager.com/gtag/js?id=UA-150864696-8"></script>

          



    <script defer>
        (function (h, o, t, j, a, r) {
            h.hj = h.hj || function () {
                (h.hj.q = h.hj.q || []).push(arguments)
            };
            h._hjSettings = {
                hjid: 1883463,
                hjsv: 6
            };
            a = o.getElementsByTagName('head')[0];
            r = o.createElement('script');
            r.async = 1;
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
            a.appendChild(r);
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    </script>

<script type="text/javascript" id="zsiqchat">var $zoho=$zoho || {};$zoho.salesiq = $zoho.salesiq || {widgetcode: "siq296f0719b6f95568d64f07b5076b3c7b8b132c12f8305f0f172741d687b830a5", values:{},ready:function(){}};var d=document;s=d.createElement("script");s.type="text/javascript";s.id="zsiqscript";s.defer=true;s.src="https://salesiq.zohopublic.in/widget";t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t);</script>





</head>

<body> -->

    <style>
        .fading-1 {
      background: 
      linear-gradient(90deg, transparent, #2F9EDD, transparent) 
        bottom /var(--d, 0) 3px no-repeat;
      transition: 0.5s;
    }
    .fading-1:hover {
      --d: 100%;
    }
    </style>
    
    
    <!--====================  header area ====================-->
    <div class="header-area header-area--absolute">
        <div class="preview-header-inner header-sticky">
            <div class="container-fluid container-fluid--cp-150" style="padding: 0">
                <div class="row header_row">
                    <div class="col-6 col-lg-6 col-xl-12">
                        <div class="header position-relative">
                            <!-- brand logo -->
                            <div class="header__logo">
                                <a href="/" class="headderLogoSection">
                                    <img id="headerlogo" src="../../../assets/images/homepage/update-mitimage.png"
                                        class="img-fluid light-logo" alt="magantiit logo" />
                                    <img src="../../../assets/images/homepage/update-mitimage.png"
                                        class="img-fluid dark-logo img img-responsive" alt="mit logo" />
                                </a>
                            </div>
                            <!-- navigation menu -->
                            <div class="header__navigation menu-style-four preview-menu d-none d-xl-block">
                                <nav class="navigation-menu navigation-menu--onepage navigation">
                                    
                                    <ul class="maniMenu">
                                       
                                        <li class="has-children">
                                            <a ><span>Services</span></a>
                                            <ul class="megamenu megamenu--mega p-0  ">
                                                <li class="list-services subMenuItem">
                                                    <div class="subMenuClass subMenuClassActive">
                                                        <h2 class="subMenuTitle">Services</h2>
                                                        <p class="currentMenuInfo">Discover our portfolio -constantly
                                                            evolving to keep pace with the ever-changing needs of our
                                                            clients.</p>
                                                    </div>
                                                </li>
                                                <li class="technology-service">
                                                    <h2 class="subMenuTitle">Technology Development</h2>
                                                    <ul class="listdetails">
                                                        <li> <a 
                                                                href="application-services" class="subMenuLink fading-1">
                                                                <i class="fa fa-desktop tech-size"
                                                                    aria-hidden="true"></i><span
                                                                    class="tech-app technologydevelop_hover">Application
                                                                    Development</span></a> </li>
                                                        <li> <a href="mobileservices"
                                                                class="subMenuLink fading-1"><span class="technologydevelop_hover">
                                                                    <i class="fa fa-mobile MobileApplicationDevelopment"
                                                                        aria-hidden="true"> </i>
                                                                    Mobile App Development</span></a> </li>
                                                        <li> <a  href="cloudservices"
                                                                class="subMenuLink fading-1"><span class="technologydevelop_hover">
                                                                    <i class="fa fa-cloud tech-size" aria-hidden="true"></i>
                                                                    Cloud Computing Services </span></a> </li>
                                                                    <li> <a  href="cybersecurityservices"
                                                                        class="subMenuLink fading-1"><span class="technologydevelop_hover">
                                                                            <!-- <i class="fa fa-cloud tech-size"></i> -->
                                                                            <i class="fa-solid fa-shield-halved"  aria-hidden="true"></i>
                                                                        Cyber Security Services </span></a> </li>
                                                        <li> <a 
                                                                href="database-services" class="subMenuLink fading-1">
                                                               
                                                                <span class="technologydevelop_hover">
                                                                    <i class="fa fa-database tech-size" aria-hidden="true"></i>Database Services
                                                                </span></a> </li>
    
                                                        <li> <a 
                                                                href="operation-maintanance" class="subMenuLink fading-1">
                                                              
                                                                <span class="technologydevelop_hover">
                                                                    <i class="fa fa-wrench tech-size" aria-hidden="true"></i>Operation and
                                                                    Maintainence </span> </a> </li>
                                                        <!-- <li> <a href="artificial-intelligence" class="subMenuLink">
                                                         <i class='fas fa-brain' aria-hidden="true"></i>
                                                                    <span class="technologydevelop_hover">AI / ML</span> </a> </li> -->
                                                        <li> <a 
                                                                href="artificial-intelligence" class="subMenuLink fading-1">
                                                              
                                                                <span class="technologydevelop_hover">
                                                                    <i class="fa-solid fa-brain tech-size" aria-hidden="true"
                                                                    style="margin-left: 0px;"></i>AI / ML
                                                                    Services</span> </a> </li>
                                                                    <li> <a 
                                                                        href="testing-services" class="subMenuLink fading-1">
                                                                      
                                                                        <span class="technologydevelop_hover">
                                                                            <i class="fa fa-cogs tech-size" aria-hidden="true"
                                                                            style="margin-left: 0px;"></i>Testing
                                                                            Services</span> </a> </li>
                                                    </ul>
                                                </li>
                                                <li class="subMenuItem">
                                                    <div class="subMenuClass">
                                                        <h2 class="subMenuTitle">Technology Staffing</h2>
                                                        <span class="currentMenuInfo">We provide end-to-end staffing
                                                            service to IT companies by finding top talent to meet
                                                            enterprise-specific needs </span>
                                                        <div class="header_bottom">
                                                            <a 
                                                                href="technology-staffing" class="subMenuButton text-right">
                                                                <span class="circle" aria-hidden="true">
                                                                    <span class="icon arrow "></span>
                                                                </span>
                                                                <span class="button-text subMenuButtonInner">Learn
                                                                    More</span>
                                                            </a>
                                                        </div>
    
                                                    </div>
                                                </li>
                                                <li class="subMenuItem">
                                                    <div class="subMenuClass">
                                                        <h2 class="subMenuTitle">Technology Training</h2>
                                                        <span class="currentMenuInfo">Service Strategies that can help
                                                            your organization achieve real, measurable results through
                                                            our structured technical support and services training
                                                        </span>
                                                        <div class="header_bottom">
                                                            <a 
                                                                href="/technology-training" class="subMenuButton text-right">
                                                                <span class="circle" aria-hidden="true">
                                                                    <span class="icon arrow "></span>
                                                                </span>
                                                                <span class="button-text subMenuButtonInner">Learn
                                                                    More</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="subMenuItem">
                                                    <div class="subMenuClass">
                                                        <h2 class="subMenuTitle">Digital Marketing</h2>
                                                        <span class="currentMenuInfo">Full-service digital agency
                                                            providing customised perfomance marketing strategies to
                                                            empower business growth</span>
                                                        <div class="header_bottom">
                                                            <a href="https://mitdigital360.com/" target=”_blank
                                                                class="subMenuButton text-right">
                                                                <span class="circle" aria-hidden="true">
                                                                    <span class="icon arrow "></span>
                                                                </span>
                                                                <span class="button-text subMenuButtonInner">Learn
                                                                    More</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="has-children">
                                            <a ><span>Industries</span></a>
                                            <ul class="megamenu megamenu--mega p-0 ">
                                                <li class="list-services subMenuItem">
                                                    <div class="subMenuClass subMenuClassActive">
                                                        <div class="subMenuTitle fifthheading">Industries</div>
                                                        <p class="currentMenuInfo">We understand the complexities of
                                                            modern markets and translate them into real business
                                                            solutions. See how we work with various industries</p>
                                                    </div>
                                                </li>
                                                <li class="subMenuItem">
                                                    <div class="subMenuClass">
                                                        <h2 class="subMenuTitle">Manufacturing</h2>
                                                        <span class="currentMenuInfo">Leverage our digital manufacturing
                                                            solutions to improve operations, control costs, and maximize
                                                            ROI of your manufacturing organization </span>
                                                        <div class="header_bottom">
                                                            <a routerlink="manufacturing"
                                                            href="manufacturing"
                                                                class="subMenuButton text-right">
                                                                <span class="circle" aria-hidden="true">
                                                                    <span class="icon arrow "></span>
                                                                </span>
                                                                <span class="button-text subMenuButtonInner">Learn
                                                                    More</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="subMenuItem">
                                                    <div class="subMenuClass">
                                                        <h2 class="subMenuTitle">Finance</h2>
                                                        <span class="currentMenuInfo">We offer expert FinTech services
                                                            to address the administration, accounting, compliance, and
                                                            surveillance demands of today's market</span>
                                                        <div class="header_bottom">
                                                            <a href="finance"
                                                                class="subMenuButton text-right">
                                                                <span class="circle" aria-hidden="true">
                                                                    <span class="icon arrow "></span>
                                                                </span>
                                                                <span class="button-text subMenuButtonInner">Learn
                                                                    More</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="subMenuItem">
                                                    <div class="subMenuClass">
                                                        <h2 class="subMenuTitle">Entertainment</h2>
                                                        <span class="currentMenuInfo">Turnkey IT solution for the media
                                                            industry, to leverage their assets, enhance business
                                                            operations, and to stay competitive in the Global
                                                            Market</span>
                                                        <div class="header_bottom">
                                                            <a routerlink="entertainment"
                                                                href="entertainment"
                                                                class="subMenuButton text-right">
                                                                <span class="circle" aria-hidden="true">
                                                                    <span class="icon arrow "></span>
                                                                </span>
                                                                <span class="button-text subMenuButtonInner">Learn
                                                                    More</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="subMenuItem">
                                                    <div class="subMenuClass">
                                                        <h2 class="subMenuTitle">Retail</h2>
                                                        <span class="currentMenuInfo">Understand shoppers' behavior,
                                                            uncover business opportunities and streamline supply-chain
                                                            operations with Maganti IT Retail Solutions</span>
                                                        <div class="header_bottom">
                                                            <a routerlink="retail" href="retail"
                                                                class="subMenuButton text-right">
                                                                <span class="circle" aria-hidden="true">
                                                                    <span class="icon arrow "></span>
                                                                </span>
                                                                <span class="button-text subMenuButtonInner">Learn
                                                                    More</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                        <!-- <li class="has-children">
                                            <a ><span>About</span></a>
                                            <ul class="megamenu megamenu--mega p-0 ">
                                                <li class="list-services subMenuItem">
                                                    <div class="subMenuClass subMenuClassActive">
                                                        <div class="subMenuTitle fifthheading">About</div>
                                                        <p class="currentMenuInfo">Maganti IT Resources is a globally
                                                            recognized IT organization serving global brands and
                                                            businesses with innovative solutions. Get to know about us
                                                        </p>
                                                    </div>
                                                </li>
                                                <li class="subMenuItem">
                                                    <div class="subMenuClass">
                                                        <h2 class="subMenuTitle">Journey</h2>
                                                        <span class="currentMenuInfo">A complete timeline of our History
                                                            from founding to present including key milestones and major
                                                            events</span>
                                                        <div class="header_bottom">
                                                            <a routerlink="journey" href="journey"
                                                                class="subMenuButton text-right">
                                                                <span class="circle" aria-hidden="true">
                                                                    <span class="icon arrow "></span>
                                                                </span>
                                                                <span class="button-text subMenuButtonInner">Learn
                                                                    More</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="subMenuItem">
                                                    <div class="subMenuClass">
                                                        <h2 class="subMenuTitle">Team</h2>
                                                        <span class="currentMenuInfo">We’re a fun, creative and
                                                            ambitious team passionate to create impeccable digital
                                                            experiences for local to global brands</span>
    
                                                        <div class="header_bottom">
                                                            <a routerlink="teams" href="teams"
                                                                class="subMenuButton text-right">
                                                                <span class="circle" aria-hidden="true">
                                                                    <span class="icon arrow "></span>
                                                                </span>
                                                                <span class="button-text subMenuButtonInner">Learn
                                                                    More</span>
                                                            </a>
                                                        </div>
    
    
                                                    </div>
                                                </li> 
                                                <li class="subMenuItem">
                                                    <div class="subMenuClass">
                                                        <h2 class="subMenuTitle">Recognition</h2>
                                                        <span class="currentMenuInfo">A glimpse of what our Employees
                                                            and clients talk about Us</span>
                                                        <div class="header_bottom">
                                                            <a routerlink="recognition" href="recognition"
                                                                class="subMenuButton text-right">
                                                                <span class="circle" aria-hidden="true">
                                                                    <span class="icon arrow "></span>
                                                                </span>
                                                                <span class="button-text subMenuButtonInner">Learn
                                                                    More</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="subMenuItem">
                                                    <div class="subMenuClass">
                                                        <h2 class="subMenuTitle">Corporate Giving</h2>
                                                        <span class="currentMenuInfo">We pride ourselves on giving back
                                                            to the community and supporting local business and
                                                            organisations</span>
                                                        <div class="header_bottom">
                                                            <a routerlink="corporate-giving"
                                                                href="corporate-giving"
                                                                class="subMenuButton text-right">
                                                                <span class="circle" aria-hidden="true">
                                                                    <span class="icon arrow "></span>
                                                                </span>
                                                                <span class="button-text subMenuButtonInner">Learn
                                                                    More</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                       </li> -->
                                       <li class="has-children">
                                        <a><span>About</span></a>
                                        <ul class="newmegamenu megamenu megamenu--mega p-0">
                                            <li class="insight-services subMenuItem smbMenu50Width">
                                                <div class="subMenuClass subMenuClassActive">
                                                <div class="subMenuTitle fifthheading">About</div>
                                                    <p class="currentMenuInfo">Maganti IT Resources is a globally
                                                        recognized IT organization serving global brands and
                                                        businesses with innovative solutions. Get to know about us</p>
                                                </div>
                                            </li>
                                            <li class="casestudy-list subMenuItem smbMenu50Width">
                                                <div class="subMenuClass">
                                                    <h2 class="subMenuTitle">Journey</h2>
                                                    <span class="currentMenuInfo">A complete timeline of our History
                                                        from founding to present including key milestones and major
                                                        events</span>
                                                        <div class="header_bottom">
                                                        <a href="journey" class="subMenuButton text-right">
                                                        <span class="circle" aria-hidden="true">
                                                            <span class="icon arrow "></span>
                                                        </span>
                                                        <span class="button-text subMenuButtonInner">Learn More</span>
                                                    </a>
                                                        </div>
                                                </div>
                                            </li>
                                            <li class="subMenuItem smbMenu50Width">
                                                <div class="subMenuClass">
                                                    <h2 class="subMenuTitle">Recognition</h2>
                                                    <span class="currentMenuInfo">A glimpse of what our Employees
                                                        and clients talk about Us
                                                    </span>
                                                    <div class="header_bottom">
                                                    <a href="recognition" class="subMenuButton text-right">
                                                        <span class="circle" aria-hidden="true">
                                                            <span class="icon arrow "></span>
                                                        </span>
                                                        <span class="button-text subMenuButtonInner">Learn More</span>
                                                    </a>
                                        </div>                                                  
                                     </div>
                                            </li>
                                                  <li class="subMenuItem smbMenu50Width">
                                                <div class="subMenuClass">
                                                    <h2 class="subMenuTitle">Corporate Giving</h2>
                                                    <span class="currentMenuInfo">We pride ourselves on giving back
                                                        to the community and supporting local business and
                                                        organisations
                                                    </span>
                                                    <div class="header_bottom">
                                                    <a href="corporate-giving" class="subMenuButton text-right">
                                                        <span class="circle" aria-hidden="true">
                                                            <span class="icon arrow "></span>
                                                        </span>
                                                        <span class="button-text subMenuButtonInner">Learn More</span>
                                                    </a>
                                        </div>                                                  
                                     </div>
                                            </li>
                                        </ul>
                                    </li>



















                                       
                                        <li class="has-children">
                                            <a><span>Insights</span></a>
                                            <ul class="newmegamenu megamenu megamenu--mega p-0" style="width:50%">
                                                <li class="insight-services subMenuItem smbMenu50Width">
                                                    <div class="subMenuClass subMenuClassActive">
                                                        <div class="subMenuTitle fifthheading">Insights</div>
                                                        <p class="currentMenuInfo">Explore our latest thought
                                                            leadership, ideas, and insights on the issues that are
                                                            shaping the future of business</p>
                                                    </div>
                                                </li>
                                                <li class="casestudy-list subMenuItem smbMenu50Width">
                                                    <div class="subMenuClass">
                                                        <h2 class="subMenuTitle">Case Studies</h2>
                                                        <span class="currentMenuInfo">Discover our portfolio constantly
                                                            evolving to keep pace with the ever-changing needs of our
                                                            clients</span>
    
                                                        <div class="header_bottom">
                                                            <a routerlink="case-studies"
                                                                href="case-studies"
                                                                class="subMenuButton text-right">
                                                                <span class="circle" aria-hidden="true">
                                                                    <span class="icon arrow "></span>
                                                                </span>
                                                                <span class="button-text subMenuButtonInner">Learn
                                                                    More</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="subMenuItem smbMenu50Width">
                                                    <div class="subMenuClass">
                                                        <h2 class="subMenuTitle">Blogs</h2>
                                                        <span class="currentMenuInfo">Explore Maganti IT blog with tons
                                                            of articles and resources about technology development
                                                        </span>
                                                        <div class="header_bottom">
                                                            <a routerlink="blogs" href="blogs"
                                                                class="subMenuButton text-right">
                                                                <span class="circle" aria-hidden="true">
                                                                    <span class="icon arrow "></span>
                                                                </span>
                                                                <span class="button-text subMenuButtonInner">Learn
                                                                    More</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="has-children">
                                            <a ><span>Careers</span></a>
                                            <ul class="newmegamenu megamenu megamenu--mega p-0" style="width:50%">
                                                <li class="insight-services subMenuItem smbMenu50Width">
                                                    <div class="subMenuClass subMenuClassActive">
                                                        <div class="subMenuTitle fifthheading">Careers</div>
                                                        <p class="currentMenuInfo">Become part of a strong team of
                                                            thinkers, entrepreneurs, and experts – and help us to make a
                                                            difference</p>
                                                    </div>
                                                </li>
                                                <li class="casestudy-list subMenuItem smbMenu50Width">
                                                    <div class="subMenuClass">
                                                        <h2 class="subMenuTitle">Explore Jobs</h2>
                                                        <span class="currentMenuInfo">Explore our jobs in various
                                                            domains of IT, Marketing and consulting and see how you can
                                                            fit</span>
                                                        <div class="header_bottom">
                                                            <a routerlink="careers" href="careers"
                                                                class="subMenuButton text-right">
                                                                <span class="circle" aria-hidden="true">
                                                                    <span class="icon arrow "></span>
                                                                </span>
                                                                <span class="button-text subMenuButtonInner">Learn
                                                                    More</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li class="casestudy-list subMenuItem smbMenu50Width">
                                                    <div class="subMenuClass">
                                                        <h2 class="subMenuTitle">Sparkminds</h2>
                                                        <span class="currentMenuInfo">Are you a recent graduate or
                                                            looking to start your first IT career? Join our Training and
                                                            Internship program to gain practical skills and launch your
                                                            career in Maganti IT</span>
                                                        <div class="header_bottom">
                                                            <a routerlink="internship" href="internship"
                                                                class="subMenuButton text-right">
                                                                <span class="circle" aria-hidden="true">
                                                                    <span class="icon arrow "></span>
                                                                </span>
                                                                <span class="button-text subMenuButtonInner">Learn
                                                                    More</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
    
                                        <li>
                                            <a routerLink="mitevents" href="mitevents"><span>Meetups</span></a>
                                        </li>
                                        <li>
                                            <a routerLink="contact" href="contact"><span>Contact</span></a>
                                        </li>
                                    </ul>
    
                                    <div style="float: right;margin-right: 15px;" class="mt-1">
                                        <ul class="list ht-social-networks">
                                            <li class="item">
                                                <a href="https://www.linkedin.com/company/maganti-it-resources-llc/mycompany/"
                                                    target="_blank" aria-label="Linkedin"
                                                    class="social-link hint--bounce hint--bottom hint--primary">
                                                    <i class="fa-brands fa-linkedin-in" aria-hidden="true"></i>
    
                                                </a>
                                            </li>
                                            <li class="item">
                                                <a href="https://twitter.com/mitresource" target="_blank"
                                                    aria-label="Twitter"
                                                    class="social-link hint--bounce hint--bottom hint--primary">
                                                    <img src="../../../assets/images/banners/twitterlogo.png" loading="lazy"
                                                        alt="twitter latest" width='42px' height="18px" />
                                                </a>
                                            </li>
                                            <li class="item">
                                                <a href="https://www.instagram.com/magantiit/" target="_blank"
                                                    aria-label="Instagram"
                                                    class="social-link hint--bounce hint--bottom hint--primary">
                                                    <i class="fa-brands  fa-instagram" aria-hidden="true"></i>
                                                </a>
                                            </li>
                                            <!-- <li class="item">
                                                    <a href="https://www.facebook.com/MagantiItResources/" target="_blank"
                                                        aria-label="Facebook"
                                                        class="social-link hint--bounce hint--bottom hint--primary">
                                                        <i class="fa fa-facebook" aria-hidden="true"></i>
                                                    </a>
                                                </li> -->
                                        </ul>
                                    </div>
    
    
                                    <!-- <div class="contactInfo">
                                            <ul class="header-top-info ">
                                                <li>
                                                    <a class="header-mobile px-1" href="1-855-217-4637"><i
                                                            class="fa fa-phone"
                                                            aria-hidden="true"></i>&nbsp;<span>1-855-217-4637</span></a>
                                                </li>
                                                <li>
                                                    <a class="header-mailsupport px-1" href="mailto:support@gmail.com"><i
                                                            class="fa fa-envelope-o" aria-hidden="true"></i>&nbsp;
                                                        &nbsp;<span>info@mitresource.com</span></a>
                                                </li>
                                            </ul>
                                        </div> -->
    
                                </nav>
                            </div>
                        </div>
    
                    </div>
                    <!-- header actions -->
                    <div class="col-6 col-lg-6 d-flex justify-content-end">
                        <div class="header__actions">
                            <div class="header__icons-wrapper header-right-inner" id="hidden-icon-wrapper">
                            </div>
                            <!-- mobile menu -->
                            <div class="mobile-navigation-icon d-block d-xl-none" style="    top: 20px;
                                left: 0px;" id="mobile-menu-trigger" (click)="toggleMobileMenu()">
                                <i></i>
                            </div>
                            <!-- hidden icons menu -->
                            <div class="hidden-icons-menu d-block d-md-none" id="hidden-icon-trigger">
                                <a href="javascript:void(0)">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div id="space_for_header_required" class="section-space--ptb_120"></div>
    
    <!-- ====================  mobile menu overlay ====================-->
    <div class="mobile-menu-overlay d-xl-none" [ngClass]="{'active': isMenuActive}" (click)="closeMobileMenuIfOutside($event)">
        <div class="mobile-menu-overlay__inner" (click)="$event.stopPropagation()">
          <div class="mobile-menu-overlay__header">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div class="col-md-6 col-8">
                  <div class="homepage">
                    <a href={{webUrl}}>
                      <img src="../../../assets/images/homepage/newmitlogo.png" class="img-fluid" alt="newlogo mit" />
                    </a>
                  </div>
                </div>
                <div class="col-md-6 col-4">
                  <div class="mobile-menu-content text-end">
                    <span class="mobile-navigation-close-icon" id="mobile-menu-close-trigger" (click)="closeMobileMenu()"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mobile-menu-overlay__body">
            <nav class="offcanvas-navigation offcanvas-navigation--onepage">
              <ul>
                <li class="has-children" *ngFor="let item of menuItems" [ngClass]="{'active': item.isOpen}">
                  <a [href]="item.link?item.link:'#'" (click)="item.subItems && item.subItems.length > 0 ? toggleSubMenu($event, item) : null">
                    {{ item.title }}
                    <i class="fa" *ngIf="item.subItems && item.subItems.length > 0" [ngClass]="item.isOpen ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" class="chevron"></i>
                  </a>
                  <ul class="sub-menu" *ngIf="item.isOpen">
                    <li *ngFor="let subItem of item.subItems" [ngClass]="{'has-children': subItem.subItems && subItem.subItems.length > 0}">
                      <a href="{{ subItem.link }}" (click)="subItem.subItems && subItem.subItems.length > 0 ? toggleSubMenu($event, subItem) : null">
                       
                        {{ subItem.title }}
                        <i  *ngIf="subItem.subItems && subItem.subItems.length > 0" [ngClass]="subItem.isOpen ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" class="chevron"></i>
                      </a>
                      <ul class="sub-menu" *ngIf="subItem.isOpen && subItem.subItems && subItem.subItems.length > 0">
                        <li *ngFor="let subSubItem of subItem.subItems">
                         <a href="{{ subSubItem.link }}">                        <i class="" *ngIf="subSubItem.icon" [ngClass]="subSubItem.icon"></i>
                            <span>{{ subSubItem.title }}</span></a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
            <div style="float: right;">
              <ul class="list ht-social-networks">
                <li class="item">
                    <a href="https://www.linkedin.com/company/maganti-it-resources-llc/mycompany/"
                    target="_blank" aria-label="Linkedin"
                    class="social-link hint--bounce hint--bottom hint--primary">
                    <i class="fa-brands fa-linkedin-in" aria-hidden="true"></i>
    
                </a>
                </li>
                <li class="item">
                  <a href="https://twitter.com/mitresource" target="_blank" aria-label="Twitter" class="social-link hint--bounce hint--bottom hint--primary">
                    <img src="../../../assets/images/banners/twitterlogo.png" alt="twitter latest" width='42px' height="18px" style="filter: brightness(0) invert(1);" />
                  </a>
                </li>
                <li class="item">
                    <a href="https://www.instagram.com/magantiit/" target="_blank"
                    aria-label="Instagram"
                    class="social-link hint--bounce hint--bottom hint--primary">
                    <i class="fa-brands  fa-instagram" aria-hidden="true"></i>
                </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
    
    
    
    <!--====================  End of mobile menu overlay  ====================-->
    <!-- <====================  mobile menu overlay ====================-->
    
    
    <!-- <script>
        let header = document.getElementsByClassName('header')[0];
        let subMenuLists = header.querySelectorAll('.has-children .megamenu');
        subMenuLists.forEach(x => {
            x.style.display = 'none';
            setTimeout(() => {
                x.style.display = ''
            }, 369)
        })
    </script>
     -->
    <!--====================  End of header area  ====================-->